import { Controller } from 'stimulus';
import $ from 'jquery';
import Selectize from 'selectize';
import { createDatepicker, teamDateFormat, Datepicker } from '@/js/modules/datepicker';

const DELAY_CLOSE_PLUGIN = 'billable_due_date_delay_close';
let delayClosePluginRegistered = false;

export default class extends Controller {
  connect() {
    this.#registerDelayClosePlugin();

    $(this.element).selectize({
      plugins: [DELAY_CLOSE_PLUGIN],
      persist: false,
      create: false,
      onChange: () => this.dispatch('changed'),
      onDropdownOpen: ($dropdown) => this.#openDropdown($dropdown),
      onDropdownClose: () => this.#destroyDatepicker(),
    });

    this.selectize = this.element.selectize;
    this.selectize.addOption({ text: 'Custom', value: 'custom' });
  }

  disconnect() {
    this.#destroyDatepicker();
    this.selectize?.destroy();
  }

  #openDropdown($dropdown) {
    $dropdown.find('.option').each((_, option) => {
      const value = option.dataset.value;

      // Hide the persisted custom date; show only payment terms and the date picker.
      if (value !== 'custom' && !/^\d+$/.test(value)) {
        option.classList.add('hide');
      }
    });

    this.customOption = $dropdown[0].querySelector('[data-value="custom"]');
    this.customOption.removeAttribute('data-selectable');
    this.customOption.classList.add('billable-due-date__custom-option');
    this.customOption.addEventListener('mouseover', this.#openDatepicker);
    this.customOption.addEventListener('mousedown', this.#keepDatepickerOpen);
  }

  #openDatepicker = (event) => {
    const option = event.currentTarget;
    [...option.parentElement.children].forEach((sibling) => sibling.classList.remove('active'));

    if (this.optionDatepicker) {
      return;
    }

    this.optionDatepicker = createDatepicker(option);

    if (this.#customDate()) {
      this.optionDatepicker.setDate(this.#customDate());
    }

    option.addEventListener('changeDate', this.#dateChosen);
  };

  #dateChosen = (event) => {
    const dateText = Datepicker.formatDate(event.detail.date, teamDateFormat());
    this.selectize.addOption({ value: dateText, text: dateText });
    this.selectize.addItem(dateText);
  };

  // The select holds either a payment term in days ("0", "15", "30"…) or a
  // formatted custom date. Only the latter means anything to the picker: given
  // "0" it parses a month of zero and opens on December of the previous year,
  // pre-selecting today's day-of-month.
  #customDate() {
    const value = this.element.value;
    return /^\d+$/.test(value) ? null : value;
  }

  #keepDatepickerOpen = (event) => {
    if (event.target.closest('.datepicker')) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  #destroyDatepicker() {
    if (!this.customOption) {
      return;
    }

    this.customOption.removeEventListener('mouseover', this.#openDatepicker);
    this.customOption.removeEventListener('mousedown', this.#keepDatepickerOpen);
    this.customOption.removeEventListener('changeDate', this.#dateChosen);

    this.optionDatepicker?.destroy();
    this.optionDatepicker = null;
    this.customOption = null;
  }

  #registerDelayClosePlugin() {
    if (delayClosePluginRegistered) {
      return;
    }

    Selectize.define(DELAY_CLOSE_PLUGIN, function () {
      const selectize = this;
      const close = selectize.close;

      selectize.close = function () {
        window.setTimeout(() => close.apply(this), 100);
      };
    });

    delayClosePluginRegistered = true;
  }
}
